module.exports = __webpack_public_path__ + "img/leaf.ec6d381b.svg";